
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiClose } from "@mdi/js";
import { Getter } from "vuex-class";

@Component({
  components: {
    SvgIcon,
  },
  computed: {
    ...mapState("banner", ["logAs", "communicate", "hasUserPassword"]),
  },
})
export default class MyBanner extends Vue {
  get isDisplayed(): boolean {
    return !this.forceCLose && (
      this.logAs !== null
      || this.communicate !== null
      || this.displaySetCredentials
    );
  }
  get displaySetCredentials(): boolean {
    return this.currentUser && !this.currentUser.password && !this.hasUserPassword;
  }
  // Déclaration de la propriété logAs
  public logAs!: string | null;
  public communicate!: string | null;

  @Getter private currentUser: any;
  private mdiClose: any = mdiClose;
  private forceCLose: boolean = false;
  private hasUserPassword: boolean;
  public close() {
    this.forceCLose = true;
    if (!this.hasUserPassword) {
      this.$store.dispatch("banner/setHasUserPassword", true);
    }
  }
}
